import PropTypes from 'prop-types'
import React from 'react'

import { FOOTER_HEIGHT } from '@/utils/constants'

/**
 * NOTE: The repeated skeleton bar pattern (`bg-…/animate-pulse/rounded-sm`) is
 * shared with RepairOrderSkeleton, ContactDetailsSection, MetricCard, etc.
 * A reusable <Skeleton /> primitive could unify all of these. Tracked for follow-up.
 */

const MessageBubbleSkeleton = ({ align, widthClass }) => {
  const isRight = align === 'right'

  return (
    <li className={`pb-6 ${isRight ? 'self-end text-right' : 'self-start text-left'}`}>
      <div
        className={`mb-2 ${widthClass} animate-pulse p-2 ${
          isRight
            ? 'self-start rounded-b-md rounded-tl-md bg-white/20'
            : 'self-end rounded-t-md rounded-br-md bg-blue-500/30'
        }`}
      >
        <div className="flex flex-col gap-1.5">
          <div className="h-3.5 w-full rounded-sm bg-white/10" />
          <div className="h-3.5 w-3/4 rounded-sm bg-white/10" />
        </div>
      </div>
      <div
        className={`h-3 w-24 animate-pulse rounded-sm bg-white/10 ${isRight ? 'ml-auto' : ''}`}
      />
    </li>
  )
}

MessageBubbleSkeleton.defaultProps = {
  align: 'left',
  widthClass: 'w-48',
}

MessageBubbleSkeleton.propTypes = {
  align: PropTypes.oneOf(['left', 'right']),
  widthClass: PropTypes.string,
}

/**
 * Loading skeleton for the RO chat sidebar.
 * Mirrors RepairOrderChat layout: messages, compose area.
 */
const RepairOrderChatSkeleton = () => (
  <aside className="bg-midnight-950/90 relative ml-0 h-full md:min-w-[489px]">
    <div className="absolute inset-y-0 right-0 flex w-full grow flex-col">
      {/* Messages area */}
      <div className="grow overflow-y-auto p-4">
        {/* Day separator */}
        <div className="mb-8 flex justify-center">
          <div className="h-3.5 w-36 animate-pulse rounded-sm bg-white/10" />
        </div>

        <ol className="flex flex-col">
          <MessageBubbleSkeleton align="left" widthClass="w-[200px]" />
          <MessageBubbleSkeleton align="right" widthClass="w-[240px]" />
          <MessageBubbleSkeleton align="left" widthClass="w-[180px]" />
        </ol>
      </div>

      {/* Compose area */}
      <div
        className="bg-midnight-950 flex w-full items-center gap-2 p-4"
        style={{ height: `${FOOTER_HEIGHT}px` }}
      >
        <div className="min-h-[75px] w-full animate-pulse rounded-lg bg-white/10" />
        <div className="h-12 w-14 shrink-0 animate-pulse rounded-lg bg-blue-800/40" />
      </div>
    </div>
  </aside>
)

export default RepairOrderChatSkeleton
